import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import { AlertCircle } from 'lucide-react'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * 受保护路由组件
 * 用于需要登录才能访问的页面（如：我的数据中心、用户资料、数据服务申请）
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation()
  const { isAuthenticated } = useAuthStore()

  // 如果未登录，重定向到登录页面，并保存当前页面路径用于登录后返回
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default ProtectedRoute